export default function () {
  return import(/* webpackChunkName: "signature_pad" */ "signature_pad").then(
    (res) => res.default
  );
}
